export enum InfoMessageType {
	info,
	warning,
	error,
	success,
	upgrade,
}
